import React from 'react';
import PropTypes from 'prop-types';

import { CompletionHeader } from './RegistrationCompletePanelStyles';

const RegistrationCompletePanel = ({ isPriorRegistration}) => {
  return (
    <>
      <CompletionHeader>{ isPriorRegistration ? 'This account already exists.' : 'We\'ve received your information!' }</CompletionHeader>
      {
        isPriorRegistration
          ? <p>
            Your account has already been created. Please sign in to your account to continue.
          </p>
          : <p>
            We've sent you an email — please check your inbox to confirm your email address.{' '}
            If you haven't received it by the end of the day, please go back and re-enter your email.
          </p>
      }
    </>
  );
};

RegistrationCompletePanel.propTypes = {
  isPriorRegistration: PropTypes.bool.isRequired,
};

export default RegistrationCompletePanel;